import React from 'react';

interface VideoProps {
  src: string;
  className?: string;
}

function Video({ src, className }: VideoProps): React.ReactElement {
  return (
    <div className={`video ${className}`}>
      <video poster={src} autoPlay playsInline muted loop>
        <source src={`${src}/webm_720p`} type="video/webm" />
        <source src={`${src}/mp4_720p`} type="video/mp4" />
        <track kind="captions" />
      </video>
    </div>
  );
}

export default Video;
